import React, { useEffect, useState } from "react";
import drawerTemplate from "../../hoc/drawerTemplate";
import InwardEntryModal from "./InwardEntryModal";
import MaterialDetails from "./MaterialDetails";
import { MdArrowBackIos, MdAdd } from "react-icons/md";
import { GrFormSubtract } from "react-icons/gr";
import TabComponent from "./TabComponent";
import generateInwardData from "./Saviours/UpdateInwardData";
import generateOutwardData from "./Saviours/UpdateOutwardData";
import netInventoryData from "./Saviours/UpdateNetInventoryData";
import InwardCard from "./Cards/InwardCard";
import OutwardCard from "./Cards/OutwardCards/OutwardCard";
import { secondDatabase } from "../../config/firebase";
import InventoryItem from "./Components/InventoryItem";
import LoadingIcon from "./Components/LoadingIcon";
import fetchItems from "./WriteFunction/fetchCategoryItems";
import handleExportExcelInward from "./Components/ExportToExcelComponent";
import SearchAndFilterComponent from "./Components/SearchAndFilterComponent";
import handleExportExcelOutward from "./Components/handleExportExcelOutward";
import { useHistory, useLocation } from "react-router-dom";

const Inventory = () => {
  const location = useLocation();
  const history = useHistory();

  const [isComingFromVehicles, setIsComingFromVehicles] = useState(
    location.state?.comingFromVehicles || false
  );

  const [projectIdFromVehicle, setProjectIdFromVehicle] = useState(
    location.state?.projectId || null
  );

  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState(null);
  const [allProjects, setAllProjects] = useState([]);
  const [project, setProject] = useState({});
  const [materials, setMaterials] = useState([]);
  const [filteredMaterials, setFilteredMaterial] = useState([]);
  const [outwardItems, setOutwardItems] = useState([]);
  const [filteredOutwardItems, setFilteredOutwardItems] = useState([]);
  const [inwardItems, setInwardItems] = useState([]);
  const [filteredInwardItems, setFilteredInwardItems] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [entryType, setEntryType] = useState(null);
  const [material, setMaterial] = useState({});
  const [viewMaterialDetails, setViewMaterialDetails] = useState(false);
  const [selectedTab, setSelectedTab] = useState("All Materials");
  const [categoryItems, setCategoryItems] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");

  const prePrepareData = async () => {
    const localStorageData = JSON.parse(localStorage.getItem("User"));

    const tempFirmId = localStorageData.firmId;

    const useRef = await secondDatabase.ref(`userDetails/${tempFirmId}`);

    useRef.once("value", function (snapshot) {
      let data = snapshot.val();

      if (data !== null) {
        let tempProjects = Object.values(data.projects);
        setAllProjects(tempProjects);
        setProject(tempProjects[0]);
      } else {
        setAllProjects([]);
        setProject({});
      }

      if (localStorageData.userName.length > 0) {
        setUserName(localStorageData.userName);
      } else {
        if (data !== null) {
          setUserName(data?.personalDetails?.name);
        }
      }
    });
  };

  useEffect(() => {
    prePrepareData();
  }, []);

  const fetchData = async () => {
    // Fetch materials data
    setLoading(true);
    if (selectedTab === "All Materials") {
      if (!Array.isArray(project)) {
        const materialsData = await netInventoryData(project);
        setMaterials(materialsData);
      } else {
        const materialsData = await netInventoryData(allProjects);
        setMaterials(materialsData);
      }
    } else if (selectedTab === "Inward") {
      let inwardItems = await generateInwardData(project);
      setInwardItems(inwardItems);
    } else if (selectedTab === "Outward") {
      let outwardItem = await generateOutwardData(project);
      console.log("outwardItem : ", outwardItem);
      setOutwardItems(outwardItem);
    }
    setLoading(false);
    let materialItems = await fetchItems(
      project.firmDetailsID,
      project.projectID
    );
    setCategoryItems(materialItems);
  };

  useEffect(() => {
    if (Object.keys(project).length > 0) {
      setFilteredMaterial([]);
      setFilteredOutwardItems([]);
      setFilteredInwardItems([]);
      fetchData();
    }
  }, [project, selectedTab]);

  useEffect(() => {
    if (materials.length > 0 && selectedTab === "All Materials") {
      const filteredMaterials = materials.filter(
        (material) =>
          material.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          material.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
          material.status.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredMaterial(filteredMaterials);
    } else {
      selectedTab === "All Materials" && setFilteredMaterial([]);
    }
  }, [materials, searchQuery]);

  useEffect(() => {
    if (outwardItems.length > 0 && selectedTab === "Outward") {
      const lowerSearch = searchQuery.toLowerCase();

      const filteredEntries = outwardItems
        .map((entry) => {
          const outwardItemsObj = entry.outwardItems;

          if (!outwardItemsObj || typeof outwardItemsObj !== "object")
            return null;

          const filteredOutwardItems = {};

          Object.entries(outwardItemsObj).forEach(([key, item]) => {
            const category = item?.category?.toLowerCase() || "";
            const description = item?.description?.toLowerCase() || "";

            if (
              category.includes(lowerSearch) ||
              description.includes(lowerSearch)
            ) {
              filteredOutwardItems[key] = item;
            }
          });

          if (Object.keys(filteredOutwardItems).length > 0) {
            return {
              ...entry,
              outwardItems: filteredOutwardItems,
            };
          }

          return null;
        })
        .filter(Boolean); // remove nulls

      setFilteredOutwardItems(filteredEntries);
    } else {
      setFilteredOutwardItems([]);
    }
  }, [outwardItems, searchQuery, selectedTab]);

  useEffect(() => {
    if (inwardItems.length > 0 && selectedTab === "Inward") {
      const lowerSearch = searchQuery.toLowerCase();

      const filteredInwardItems = inwardItems
        .map((item) => {
          const invoices = item.invoices;

          if (!invoices || typeof invoices !== "object") return null;

          const filteredInvoices = {};

          // Loop through each invoice
          Object.entries(invoices).forEach(([invoiceId, invoice]) => {
            const invoiceItems = invoice.invoiceItems || {};
            const filteredInvoiceItems = {};

            // Filter invoiceItems based on category/description
            Object.entries(invoiceItems).forEach(([itemId, invoiceItem]) => {
              const category = invoiceItem?.category?.toLowerCase() || "";
              const description = invoiceItem?.description?.toLowerCase() || "";

              if (
                category.includes(lowerSearch) ||
                description.includes(lowerSearch)
              ) {
                filteredInvoiceItems[itemId] = invoiceItem;
              }
            });

            // If invoice has matching items, keep it
            if (Object.keys(filteredInvoiceItems).length > 0) {
              filteredInvoices[invoiceId] = {
                ...invoice,
                invoiceItems: filteredInvoiceItems,
              };
            }
          });

          // Keep the whole item only if it has matching invoices
          if (Object.keys(filteredInvoices).length > 0) {
            return {
              ...item,
              invoices: filteredInvoices,
            };
          }

          return null;
        })
        .filter(Boolean); // Remove nulls

      setFilteredInwardItems(filteredInwardItems);
    } else {
      setFilteredInwardItems([]);
    }
  }, [inwardItems, searchQuery, selectedTab]);

  const getPlusIconColor = () => {
    switch (selectedTab) {
      case "Inward":
        return "#28a745"; // Light green
      case "Outward":
        return "#dc3545"; // Light red
      default:
        return "transparent"; // Hide icon for 'All Materials'
    }
  };

  const openModal = (e, material, type) => {
    e.stopPropagation();
    setEntryType(type);
    setSelectedMaterial({ ...material, type });
  };

  const onItemSelection = async (selectedItem) => {
    console.log("I am called : ");
    setLoading(true);

    if (viewMaterialDetails) {
      console.log("viewMaterialDetails : ", viewMaterialDetails);
      let materialsData;

      if (selectedItem) {
        console.log("selectedItem inside this : ", selectedItem);
        // Single project selected
        materialsData = await netInventoryData(selectedItem);
        const updatedMaterial = materialsData.find(
          (m) => m.name === material.name && m.category === material.category
        );

        if (!updatedMaterial) {
          alert("No data found for this material in selected project");
          setLoading(false);
          return false;
        } else {
        }

        setMaterial(updatedMaterial);
        setProject(selectedItem);
      } else {
        console.log("allProjects : ", allProjects);
        // All sites selected
        materialsData = await netInventoryData(allProjects);

        // Filter materials with same name and category across all projects
        const relevantMaterials = materialsData.filter(
          (m) => m.name === material.name && m.category === material.category
        );

        if (relevantMaterials.length === 0) {
          alert("No data found for this material across any projects");
          return false;
        }

        // Create consolidated material object for all sites
        const consolidatedMaterial = {
          name: material.name,
          category: material.category,
          unit: material.unit,
          quantity: relevantMaterials.reduce((sum, m) => sum + m.quantity, 0),
          historyDetails: [], // Will be populated below
          isAllSites: true,
        };

        // Combine history details from all projects
        relevantMaterials.forEach((projectMaterial) => {
          if (projectMaterial.historyDetails) {
            const projectHistoryEntries = Object.entries(
              projectMaterial.historyDetails
            ).map(([timestamp, entry]) => ({
              ...entry,
              projectName: projectMaterial.projectName,
              timeStamp: timestamp,
              quantity: parseFloat(entry.quantity),
            }));
            consolidatedMaterial.historyDetails.push(...projectHistoryEntries);
          }
        });

        // Sort history details by timestamp (most recent first)
        consolidatedMaterial.historyDetails.sort(
          (a, b) => parseInt(b.timeStamp) - parseInt(a.timeStamp)
        );

        setMaterial(consolidatedMaterial);
        setProject(allProjects);
      }
    } else {
      console.log(
        "selectedItem inside the view material Details : ",
        selectedItem
      );
      // Regular project selection (not in material details view)
      if (selectedItem) {
        setProject(selectedItem);
      } else {
        setProject(allProjects);
      }
    }
    setLoading(false);
    return true;
  };

  // Utility function to parse dates from various formats
  const parseDateFromVariousFormats = (dateInput, debugLabel = "") => {
    if (!dateInput) return { date: null, source: "empty" };

    let parsedDate = null;
    let source = "";

    // If it's already a Date object
    if (dateInput instanceof Date) {
      return { date: dateInput, source: "date-object" };
    }

    // If it's a number (timestamp)
    if (typeof dateInput === "number") {
      parsedDate = new Date(dateInput);
      source = "number";
      if (!isNaN(parsedDate.getTime())) {
        return { date: parsedDate, source };
      }
    }

    // If it's a string
    if (typeof dateInput === "string") {
      // Try DD/MM/YYYY format
      if (dateInput.includes("/")) {
        const parts = dateInput.split("/");
        if (parts.length === 3) {
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10) - 1; // Months are 0-indexed in JS
          const year = parseInt(parts[2], 10);
          parsedDate = new Date(year, month, day);
          source = "dd/mm/yyyy";
          if (!isNaN(parsedDate.getTime())) {
            return { date: parsedDate, source };
          }
        }
      }

      // Try DD-MM-YYYY format
      if (dateInput.includes("-")) {
        // First check if it's already ISO format (YYYY-MM-DD)
        if (/^\d{4}-\d{2}-\d{2}/.test(dateInput)) {
          parsedDate = new Date(dateInput);
          source = "iso-date";
          if (!isNaN(parsedDate.getTime())) {
            return { date: parsedDate, source };
          }
        }

        // Otherwise try DD-MM-YYYY
        const parts = dateInput.split("-");
        if (parts.length === 3) {
          // Check if first part is day (less than 32) and third part is year (4 digits)
          if (parseInt(parts[0], 10) < 32 && parts[2].length === 4) {
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);
            parsedDate = new Date(year, month, day);
            source = "dd-mm-yyyy";
            if (!isNaN(parsedDate.getTime())) {
              return { date: parsedDate, source };
            }
          }
        }
      }

      // Try parsing as timestamp (string of numbers)
      if (/^\d+$/.test(dateInput)) {
        parsedDate = new Date(parseInt(dateInput, 10));
        source = "timestamp-string";
        if (!isNaN(parsedDate.getTime())) {
          return { date: parsedDate, source };
        }
      }

      // Last resort: try direct parsing
      parsedDate = new Date(dateInput);
      source = "direct-parse";
      if (!isNaN(parsedDate.getTime())) {
        return { date: parsedDate, source };
      }
    }

    // If all else fails
    if (debugLabel) {
      console.log(`Failed to parse date for ${debugLabel}:`, dateInput);
    }
    return { date: null, source: "failed" };
  };

  const filterDataWRTDate = async () => {
    // Debug function to log date parsing details
    const debugDate = (label, dateValue, source = "") => {
      if (!dateValue) return;

      console.log(
        `${label}:`,
        typeof dateValue === "string" ? dateValue : dateValue.toString(),
        "Parsed as:",
        new Date(dateValue).toISOString(),
        source ? `(Source: ${source})` : ""
      );
    };

    // Parse start and end dates using our utility
    const { date: startDateObj, source: startDateSource } =
      parseDateFromVariousFormats(startDate, "startDate");
    const { date: endDateObj, source: endDateSource } =
      parseDateFromVariousFormats(endDate, "endDate");

    // Set time to start of day for start date, end of day for end date
    if (startDateObj) {
      startDateObj.setHours(0, 0, 0, 0);
      debugDate("Start date", startDateObj, startDateSource);
    }
    if (endDateObj) {
      endDateObj.setHours(23, 59, 59, 999);
      debugDate("End date", endDateObj, endDateSource);
    }

    if (selectedTab === "Inward") {
      console.log("Inward items count before filtering:", inwardItems.length);

      // Log a few sample items to inspect their date format
      console.log(
        "Sample inward items (first 3):",
        inwardItems.slice(0, 3).map((item) => ({
          id: item.id,
          timeStamp: item.timeStamp,
          dueDate: item.dueDate,
          hasReceivedData: !!item.receivedData,
          hasInvoices: !!item.invoices,
          invoiceCount: item.invoices ? Object.keys(item.invoices).length : 0,
        }))
      );

      const filteredData = inwardItems.filter((entry) => {
        // Skip date filtering if no dates are set
        if (!startDate && !endDate) {
          return true;
        }

        // Use our utility to parse the entry date from various possible fields
        let entryDateResult;

        // For request-converted records (with dueDate property)
        if (entry.dueDate) {
          // Use receivedData.metadata.receivedDate if available
          if (entry.receivedData?.metadata?.receivedDate) {
            entryDateResult = parseDateFromVariousFormats(
              entry.receivedData.metadata.receivedDate,
              "receivedData.metadata.receivedDate"
            );
          } else {
            // Fallback to entry.id (timestamp) if receivedDate is not available
            entryDateResult = parseDateFromVariousFormats(entry.id, "entry.id");
          }
        }
        // For regular inward entries with timeStamp
        else if (entry.timeStamp) {
          entryDateResult = parseDateFromVariousFormats(
            entry.timeStamp,
            "timeStamp"
          );
        }
        // Use entry.id as last resort
        else if (entry.id) {
          entryDateResult = parseDateFromVariousFormats(entry.id, "entry.id");
        } else {
          // No date information available
          entryDateResult = { date: null, source: "no-date-field" };
        }

        const { date: entryDate, source: dateSource } = entryDateResult;

        // If entryDate is invalid or missing, include the entry when no dates are specified
        if (!entryDate || isNaN(entryDate.getTime())) {
          console.log(
            "Invalid date for entry:",
            entry.id || "unknown",
            "Raw:",
            entry.timeStamp,
            "Source:",
            dateSource
          );
          return !startDate && !endDate;
        }

        // Get the date without time
        const entryDateString = entryDate.toISOString().split("T")[0];

        const result =
          (!startDateObj || entryDate >= startDateObj) &&
          (!endDateObj || entryDate <= endDateObj);

        // Log date comparisons
        if (Math.random() < 0.2) {
          // Increase logging to 20% of entries
          console.log(
            "Date comparison:",
            "Entry date:",
            entryDateString,
            "Raw:",
            entry.timeStamp,
            "Source:",
            dateSource,
            "Start:",
            startDateObj ? startDateObj.toISOString().split("T")[0] : "none",
            "End:",
            endDateObj ? endDateObj.toISOString().split("T")[0] : "none",
            "Result:",
            result,
            "Start test:",
            !startDateObj || entryDate >= startDateObj,
            "End test:",
            !endDateObj || entryDate <= endDateObj
          );
        }

        return result;
      });

      console.log("Inward items after date filtering:", filteredData.length);

      // Display first few filtered items for debug
      if (filteredData.length > 0) {
        console.log(
          "First filtered item dates:",
          filteredData.slice(0, 3).map((item) => ({
            id: item.id,
            timeStamp: item.timeStamp,
            date: item.timeStamp
              ? typeof item.timeStamp === "number"
                ? new Date(item.timeStamp).toISOString()
                : item.timeStamp
              : item.id,
          }))
        );
      } else {
        console.log("No items found after date filtering!");
      }

      // Apply category filtering if a specific category is selected
      let categoryFilteredData = filteredData;
      if (selectedCategory !== "all") {
        categoryFilteredData = filteredData.filter((entry) => {
          if (!entry.invoices || Object.keys(entry.invoices).length === 0) {
            return false;
          }

          return Object.values(entry.invoices).some((invoice) => {
            if (!invoice.invoiceItems) return false;

            return Object.values(invoice.invoiceItems).some(
              (item) => item.category === selectedCategory
            );
          });
        });
        console.log(
          "Inward items after category filtering:",
          categoryFilteredData.length
        );
      }

      setFilteredInwardItems(categoryFilteredData);
    } else if (selectedTab === "Outward") {
      console.log("Outward items count before filtering:", outwardItems.length);

      // Log a few sample items to inspect their structure
      if (outwardItems.length > 0) {
        const sampleItem = outwardItems[0];
        console.log("Sample outward item structure:", {
          id: sampleItem.id,
          outwardItemsCount: sampleItem.outwardItems
            ? Object.keys(sampleItem.outwardItems).length
            : 0,
          firstItemSample: sampleItem.outwardItems
            ? Object.values(sampleItem.outwardItems)[0]
            : null,
        });
      }

      // For outward entries, we need to check the timestamps
      const filteredData = outwardItems.filter((entry) => {
        if (!entry.outwardItems || typeof entry.outwardItems !== "object")
          return false;

        // If no dates are set, keep all items
        if (!startDate && !endDate) {
          return true;
        }

        let hasMatchingItems = false;
        // Debug: Log timestamps from this entry
        const timestamps = [];

        // Check if any outwardItem has issueHistory within date range
        Object.entries(entry.outwardItems).forEach(([itemKey, itemValue]) => {
          const issueHistory = itemValue.issueHistory;

          if (!issueHistory || typeof issueHistory !== "object") return;

          // Check if any issueHistory entry falls within date range
          for (const [historyKey, history] of Object.entries(issueHistory)) {
            const timestamp = history?.timestamp;

            // Use our utility to parse the timestamp
            const { date: historyDate, source: historyDateSource } =
              parseDateFromVariousFormats(timestamp, "outward-timestamp");

            // Collect timestamps for debugging
            if (timestamp) {
              timestamps.push({
                raw: timestamp,
                parsed: historyDate ? historyDate.toISOString() : null,
                source: historyDateSource,
              });
            }

            // If no valid date, skip this entry
            if (!historyDate) continue;

            // Check if date is within range
            const isInRange =
              (!startDateObj || historyDate >= startDateObj) &&
              (!endDateObj || historyDate <= endDateObj);

            if (isInRange) {
              hasMatchingItems = true;
              break; // Exit the loop early if we found a match
            }
          }

          // If we already found a match, no need to continue checking
          if (hasMatchingItems) return;
        });

        // Log this entry's timestamps (for first few entries only)
        if (timestamps.length > 0 && Math.random() < 0.2) {
          console.log("Entry timestamps:", timestamps);
        }

        // Keep the entire original entry if it has any matching items
        return hasMatchingItems;
      });

      console.log("Outward items after date filtering:", filteredData.length);

      // Apply category filtering if a specific category is selected
      let categoryFilteredData = filteredData;
      if (selectedCategory !== "all") {
        categoryFilteredData = filteredData.filter((entry) => {
          if (
            !entry.outwardItems ||
            Object.keys(entry.outwardItems).length === 0
          ) {
            return false;
          }

          // Check if any outward item matches the selected category
          // This just filters which entries are shown, without modifying their content
          return Object.values(entry.outwardItems).some(
            (item) => item.category === selectedCategory
          );
        });
        console.log(
          "Outward items after category filtering:",
          categoryFilteredData.length
        );
      }

      setFilteredOutwardItems(categoryFilteredData);
    }
  };

  useEffect(() => {
    // Check if dates are valid before filtering
    const isStartDateValid = startDate && startDate !== "";
    const isEndDateValid = endDate && endDate !== "";

    // Convert to actual date objects to check validity
    let startDateObj = null;
    let endDateObj = null;

    if (isStartDateValid) {
      startDateObj = new Date(startDate);
      if (isNaN(startDateObj.getTime())) {
        console.log("Invalid start date format:", startDate);
      } else {
        console.log("Valid start date:", startDateObj.toISOString());
      }
    }

    if (isEndDateValid) {
      endDateObj = new Date(endDate);
      if (isNaN(endDateObj.getTime())) {
        console.log("Invalid end date format:", endDate);
      } else {
        console.log("Valid end date:", endDateObj.toISOString());
      }
    }

    if (isStartDateValid || isEndDateValid) {
      console.log("Applying date filter...");
      filterDataWRTDate();
    } else if (selectedTab === "Inward") {
      // If both dates are cleared, reset to show all data
      console.log("No dates selected, showing all inward items");
      setFilteredInwardItems(inwardItems);
    } else if (selectedTab === "Outward") {
      // If both dates are cleared, reset to show all data
      console.log("No dates selected, showing all outward items");
      setFilteredOutwardItems(outwardItems);
    }
  }, [startDate, endDate]);

  // Add effect to handle category changes
  useEffect(() => {
    if (selectedTab === "Inward" || selectedTab === "Outward") {
      filterDataWRTDate();
    }
  }, [selectedCategory]);

  // Add effect to handle data changes
  useEffect(() => {
    // Only filter if we have date or category filters active
    if (
      (startDate && startDate !== "") ||
      (endDate && endDate !== "") ||
      selectedCategory !== "all"
    ) {
      filterDataWRTDate();
    } else {
      // If no filters, just update the filtered state
      if (selectedTab === "Inward") {
        setFilteredInwardItems(inwardItems);
      } else if (selectedTab === "Outward") {
        setFilteredOutwardItems(outwardItems);
      }
    }
  }, [inwardItems, outwardItems]);

  // For debugging, log data when tab changes
  useEffect(() => {
    // Clear previous filter results when switching tabs
    setStartDate("");
    setEndDate("");
    setSearchQuery("");
    setSelectedCategory("all");
  }, [selectedTab]);

  const handleExcelExport = () => {
    if (selectedTab === "Inward") {
      // Get the data to export based on filters
      let dataToExport =
        filteredInwardItems && filteredInwardItems.length > 0
          ? filteredInwardItems
          : inwardItems;

      // Ensure data is an array
      if (dataToExport && !Array.isArray(dataToExport)) {
        dataToExport = Object.values(dataToExport);
      }

      if (!dataToExport || dataToExport.length === 0) {
        alert("No data available to export.");
        return;
      }

      try {
        handleExportExcelInward(dataToExport, project);
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        alert("An error occurred while exporting to Excel. Please try again.");
      }
    } else if (selectedTab === "Outward") {
      // Get the data to export based on filters
      let dataToExport =
        filteredOutwardItems && filteredOutwardItems.length > 0
          ? filteredOutwardItems
          : outwardItems;

      // Ensure data is an array
      if (dataToExport && !Array.isArray(dataToExport)) {
        dataToExport = Object.values(dataToExport);
      }

      if (!dataToExport || dataToExport.length === 0) {
        alert("No data available to export.");
        return;
      }

      try {
        handleExportExcelOutward(dataToExport, project);
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        alert("An error occurred while exporting to Excel. Please try again.");
      }
    }
  };

  useEffect(() => {
    const handleInitialSetup = async () => {
      setLoading(true);

      // First check if we have materials and coming from vehicles
      if (isComingFromVehicles && materials.length > 0) {
        const fuelMaterial = materials.find(
          (material) => material.category === "Fuel"
        );

        if (fuelMaterial) {
          // Set the initial fuel material
          setMaterial(fuelMaterial);
          setViewMaterialDetails(true);

          // Then handle project selection if projectIdFromVehicle exists
          if (projectIdFromVehicle) {
            if (projectIdFromVehicle === "All Sites") {
              const materialsData = await netInventoryData(allProjects);

              const relevantMaterials = materialsData.filter(
                (m) => m.name === fuelMaterial.name && m.category === "Fuel"
              );

              if (relevantMaterials.length > 0) {
                const consolidatedMaterial = {
                  name: fuelMaterial.name,
                  category: "Fuel",
                  unit: fuelMaterial.unit,
                  quantity: relevantMaterials.reduce(
                    (sum, m) => sum + m.quantity,
                    0
                  ),
                  historyDetails: [],
                  isAllSites: true,
                };

                relevantMaterials.forEach((projectMaterial) => {
                  if (projectMaterial.historyDetails) {
                    const projectHistoryEntries = Object.entries(
                      projectMaterial.historyDetails
                    ).map(([timestamp, entry]) => ({
                      ...entry,
                      projectName: projectMaterial.projectName,
                      timeStamp: timestamp,
                      quantity: parseFloat(entry.quantity),
                    }));
                    consolidatedMaterial.historyDetails.push(
                      ...projectHistoryEntries
                    );
                  }
                });

                consolidatedMaterial.historyDetails.sort(
                  (a, b) => parseInt(b.timeStamp) - parseInt(a.timeStamp)
                );

                setMaterial(consolidatedMaterial);
                setProject(allProjects);
              }
            } else {
              const selectedProject = allProjects.find(
                (p) => p.projectID === projectIdFromVehicle
              );

              if (selectedProject) {
                const materialsData = await netInventoryData(selectedProject);
                const updatedMaterial = materialsData.find(
                  (m) => m.name === fuelMaterial.name && m.category === "Fuel"
                );

                if (updatedMaterial) {
                  setMaterial(updatedMaterial);
                  setProject(selectedProject);
                }
              }
            }
          }
        }
      }
      // If not coming from vehicles but have projectIdFromVehicle
      else if (projectIdFromVehicle) {
        if (projectIdFromVehicle === "All Sites") {
          setProject(allProjects);
        } else {
          const selectedProject = allProjects.find(
            (p) => p.projectID === projectIdFromVehicle
          );
          if (selectedProject) {
            setProject(selectedProject);
          }
        }
      }

      setLoading(false);
    };

    handleInitialSetup();
  }, [isComingFromVehicles, materials, projectIdFromVehicle, allProjects]);

  const handleBackClick = () => {
    if (isComingFromVehicles) {
      history.push("/Vehicles");
    } else {
      setViewMaterialDetails(false);
      setIsComingFromVehicles(false); // Reset the local state
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.headingWrapper}>
        {viewMaterialDetails && (
          <button onClick={handleBackClick} style={styles.backIcon}>
            <MdArrowBackIos size={25} />
          </button>
        )}

        {viewMaterialDetails ? (
          <h1 style={styles.heading}>
            {`${material.category} | ${material.name} | Current Quantity : ${material.quantity} ${material.unit}`}
          </h1>
        ) : (
          <TabComponent
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            setSearchQuery={setSearchQuery}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
          />
        )}
      </div>

      <SearchAndFilterComponent
        allProjects={allProjects}
        onItemSelection={onItemSelection}
        loading={loading}
        setLoading={setLoading}
        viewMaterialDetails={viewMaterialDetails}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        handleExcelExport={handleExcelExport}
        selectedTab={selectedTab}
        projectIdFromVehicle={projectIdFromVehicle}
        currentProject={project}
        inwardItems={inwardItems}
        outwardItems={outwardItems}
        filteredInwardItems={filteredInwardItems}
        filteredOutwardItems={filteredOutwardItems}
        onCategoryFilterChange={setSelectedCategory}
      />

      {loading && <LoadingIcon />}

      <div style={{ overflowY: "auto", width: "100%" }}>
        {viewMaterialDetails ? (
          !loading ? (
            <MaterialDetails material={material} />
          ) : null
        ) : selectedTab === "Inward" ? (
          filteredInwardItems.map((item, index) => (
            <InwardCard itemData={item} project={project} userName={userName} />
          ))
        ) : selectedTab === "Outward" ? (
          outwardItems.map((item, index) => (
            <OutwardCard
              index={index}
              item={item}
              project={project}
              userName={userName}
            />
          ))
        ) : (
          filteredMaterials.map((material) => (
            <div
              key={material.id}
              style={styles.materialCard}
              onClick={() => {
                setViewMaterialDetails(true);
                setMaterial(material);
              }}
            >
              {/* <div style={styles.imagePlaceholder}></div> */}
              <InventoryItem material={material} />
              <div style={styles.details}>
                <div style={styles.materialName}>
                  {project.length > 1 && `${material.projectName} | `}
                  {`${material.category} | ${material.name}`}
                </div>
                <div style={styles.materialInfo}>
                  Available:{" "}
                  <span
                    style={
                      material.quantity > 0
                        ? styles.materialStatus
                        : styles.outOfStock
                    }
                  >
                    {material.quantity.toFixed(2)} {material.unit}
                  </span>
                </div>
                {console.log(
                  "material.historyDetails : ",
                  material,
                  material.historyDetails
                )}
                <div style={styles.materialInfo}>
                  Last updated:{" "}
                  {new Date(
                    parseInt(
                      Object.keys(material?.historyDetails)[
                        Object.keys(material?.historyDetails).length - 1
                      ]
                    )
                  ).toLocaleDateString()}
                </div>
              </div>
              {!Array.isArray(project) && (
                <div style={styles.buttonContainer}>
                  <button
                    style={styles.addButton}
                    onClick={(e) => openModal(e, material, "add")}
                  >
                    Add Stock
                  </button>
                  <button
                    style={styles.subtractButton}
                    onClick={(e) => openModal(e, material, "subtract")}
                  >
                    Remove Stock
                  </button>
                </div>
              )}
            </div>
          ))
        )}
      </div>

      {selectedMaterial && (
        <InwardEntryModal
          userName={userName}
          categoryItems={categoryItems}
          project={project}
          entryType={entryType}
          close={() => {
            setEntryType(null);
            setSelectedMaterial(false);
          }}
          selectedMaterial={selectedMaterial}
          fetchData={fetchData}
        />
      )}

      {selectedTab !== "All Materials" && !Array.isArray(project) && (
        <button
          style={{
            position: "fixed",
            bottom: "50px",
            right: "50px",
            backgroundColor: getPlusIconColor(),
            borderRadius: "50%", // Ensures the button is a perfect circle
            width: "60px", // Set fixed width and height for the button to maintain a circle shape
            height: "60px", // Fixed height for the button
            display: "flex",
            alignItems: "center", // Centers the icon vertically
            justifyContent: "center", // Centers the icon horizontally
            padding: "0", // Remove padding to maintain the perfect circle
            border: "none",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
            zIndex: 10,
            transition: "background-color 0.3s",
          }}
          onClick={() => {
            if (selectedTab === "Inward") {
              setEntryType("add");
              setSelectedMaterial(true);
            } else {
              setEntryType("subtract");
              setSelectedMaterial(true);
            }
          }}
        >
          {selectedTab === "Inward" ? (
            <MdAdd size={30} color="#fff" />
          ) : (
            <GrFormSubtract size={30} color="#fff" />
          )}
        </button>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    overflowY: "auto",
    maxHeight: "100vh",
    width: "100%",
  },
  heading: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "#2f4858",
    backgroundColor: "#fff",
    zIndex: 10,
    padding: "10px 0",
    width: "100%",
    display: "flex",
    alignSelf: "center",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: "10px",
    width: "100%",
    //   maxWidth: '1200px',
    justifyContent: "space-between",
    position: "sticky",
    top: "60px", // Adjust based on the height of the title
    zIndex: 9,
    backgroundColor: "#fff",
    padding: "10px 0",
  },
  searchInput: {
    width: "80%",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    fontSize: "16px",
  },
  dropdown: {
    width: "250px",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    fontSize: "16px",
    marginLeft: "10px",
  },
  materialCard: {
    width: "100%",
    padding: "15px",
    borderRadius: "12px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "15px",
    cursor: "pointer",
  },
  imagePlaceholder: {
    width: "80px",
    height: "100px",
    backgroundColor: "#f0f0f0",
    borderRadius: "8px",
    backgroundImage: 'url("https://via.placeholder.com/80x100")',
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  details: {
    flex: 1,
    marginLeft: "15px",
  },
  materialName: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#333",
  },
  materialInfo: {
    fontSize: "14px",
    color: "#666",
    margin: "4px 0",
  },
  materialStatus: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#28a745",
  },
  outOfStock: {
    color: "#dc3545",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "20px", // Space between buttons
    marginTop: "15px",
  },
  addButton: {
    padding: "12px 20px",
    backgroundColor: "#f8f9fa", // Light grey background
    color: "#28a745", // Green text
    border: "2px solid #28a745", // Green border
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "background-color 0.3s ease, transform 0.3s ease",
  },
  subtractButton: {
    padding: "12px 20px",
    backgroundColor: "#f8f9fa", // Light grey background
    color: "#dc3545", // Red text
    border: "2px solid #dc3545", // Red border
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "background-color 0.3s ease, transform 0.3s ease",
  },
  addButtonHover: {
    backgroundColor: "#e9ecef", // Slightly darker grey on hover
    transform: "scale(1.05)",
  },
  subtractButtonHover: {
    backgroundColor: "#e9ecef", // Slightly darker grey on hover
    transform: "scale(1.05)",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modal: {
    width: "300px",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    textAlign: "center",
  },
  input: {
    width: "100%",
    padding: "8px",
    marginBottom: "12px",
    borderRadius: "4px",
    border: "1px solid #ddd",
    fontSize: "16px",
  },
  modalButton: {
    width: "100%",
    padding: "10px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "#007bff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  headingWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    position: "sticky",
    top: 0,
    backgroundColor: "#fff",
    zIndex: 10,
    width: "100%",
    padding: "10px 0",
    marginBottom: "20px",
  },
  backIcon: {
    marginRight: "10px",
    cursor: "pointer",
    fontSize: "20px",
    background: "none",
    border: "none",
    color: "#2f4858",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  heading: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#2f4858",
    width: "100%",
  },
  label: {
    fontSize: "16px",
    color: "#555",
    display: "block",
    marginBottom: "5px",
    marginTop: "10px",
  },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px", // Add some space between elements
  },
  inputGroup: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "5px", // Add spacing between the label and input
  },
  button2: {
    flex: "none", // Ensure button does not stretch
    padding: "12px",
    backgroundColor: "#0066cc",
    color: "white",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  buttonHover: {
    backgroundColor: "#0055bb",
  },
  dateInput: {
    width: "100%",
    padding: "10px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    outline: "none",
    transition: "all 0.3s ease",
  },
  dateInputFocus: {
    borderColor: "#0066cc",
  },
};

export default drawerTemplate(Inventory);
